module.exports = __webpack_public_path__ + "img/worker-circle.31a5f476.png";